import { createMachine } from '@monofront/xstate-v4';
import { SELECT_TIME_SLOTS_STATES } from './states';
import { SELECT_TIME_SLOTS_TRANSITIONS } from './transitions';
import {
  ISelectTimeSlotsContext,
  ISelectTimeSlotsEvents,
  ISelectTimeSlotsServices,
} from './types';
import { isDaySelected, isHourSelected } from './guards';
import {
  selectDayTransition,
  selectHourTransition,
  clearSelectionTransition,
  assignSlotAvailabilitiesReceived,
  sendSelectedTimeSlotToParent,
} from './actions';
import { SELECT_TIME_SLOTS_EXTERNAL_SERVICES } from './services';

export const SELECT_TIME_SLOTS_ID = 'select-time-slots';

export const selectTimeSlotsMachine = createMachine<
  ISelectTimeSlotsContext,
  ISelectTimeSlotsEvents
>({
  predictableActionArguments: true,
  id: SELECT_TIME_SLOTS_ID,
  schema: {
    context: {} as ISelectTimeSlotsContext,
    events: {} as ISelectTimeSlotsEvents,
    services: {} as ISelectTimeSlotsServices,
  },
  initial: SELECT_TIME_SLOTS_STATES.INITIAL,
  context: {
    timeSlots: [],
    hourSelected: null,
    daySelected: null,
    deliveryInfos: '',
  },
  states: {
    [SELECT_TIME_SLOTS_STATES.INITIAL]: {
      on: {
        [SELECT_TIME_SLOTS_TRANSITIONS.FETCH_SLOTS]:
          SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING,
      },
    },
    [SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING]: {
      invoke: {
        src: SELECT_TIME_SLOTS_EXTERNAL_SERVICES.listTimeSlots,
        onDone: {
          target: SELECT_TIME_SLOTS_STATES.GET_SUCCESS,
          actions: assignSlotAvailabilitiesReceived,
        },
        onError: SELECT_TIME_SLOTS_STATES.GET_ERROR,
      },
    },
    [SELECT_TIME_SLOTS_STATES.GET_ERROR]: {
      on: {
        [SELECT_TIME_SLOTS_TRANSITIONS.FETCH_SLOTS]:
          SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING,
      },
    },
    [SELECT_TIME_SLOTS_STATES.GET_SUCCESS]: {
      always: [
        {
          target: SELECT_TIME_SLOTS_STATES.DAY_SELECTED,
          cond: isDaySelected,
        },
      ],
      on: {
        [SELECT_TIME_SLOTS_TRANSITIONS.SELECT_DAY]: selectDayTransition,
        [SELECT_TIME_SLOTS_TRANSITIONS.FETCH_SLOTS]:
          SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING,
      },
    },
    [SELECT_TIME_SLOTS_STATES.DAY_SELECTED]: {
      always: [
        {
          target: SELECT_TIME_SLOTS_STATES.HOUR_SELECTED,
          cond: isHourSelected,
        },
      ],
      on: {
        [SELECT_TIME_SLOTS_TRANSITIONS.SELECT_DAY]: selectDayTransition,
        [SELECT_TIME_SLOTS_TRANSITIONS.SELECT_HOUR]: selectHourTransition,
        [SELECT_TIME_SLOTS_TRANSITIONS.FETCH_SLOTS]:
          SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING,
        [SELECT_TIME_SLOTS_TRANSITIONS.CLEAR_SELECTION]:
          clearSelectionTransition,
      },
    },
    [SELECT_TIME_SLOTS_STATES.HOUR_SELECTED]: {
      entry: [sendSelectedTimeSlotToParent],
      on: {
        [SELECT_TIME_SLOTS_TRANSITIONS.SELECT_DAY]: selectDayTransition,
        [SELECT_TIME_SLOTS_TRANSITIONS.SELECT_HOUR]: selectHourTransition,
        [SELECT_TIME_SLOTS_TRANSITIONS.FETCH_SLOTS]:
          SELECT_TIME_SLOTS_STATES.SLOTS_FETCHING,
        [SELECT_TIME_SLOTS_TRANSITIONS.CLEAR_SELECTION]:
          clearSelectionTransition,
      },
    },
  },
});
